import React, { useState, useEffect, useCallback } from "react";
import { oneOfType, arrayOf, node } from "prop-types";
import Header from "components/header";
import {
  Container,
  Main,
  MainWrapper,
  UserInfoWrapper,
  Graphic,
} from "./styles";
import SideMenu from "components/menu";
import useWindowSize from "hooks/windowSize";
import { Row } from "components/shared/layout";
import UserInformation from "components/menu/userInformation";
import { HeaderRightContent } from "components/header/styles";
import { useLocation } from "@reach/router";
import { navItems } from "components/nav";

const Layout = ({ children, headerRightContent }) => {
  const [navOpen, setNavOpen] = useState(true);
  const [width] = useWindowSize();
  const location = useLocation();
  const mobile = width <= 1366;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [children]);

  useEffect(() => {
    if (!navOpen && !mobile) {
      setNavOpen(true);
    }
    if (navOpen && mobile) {
      setNavOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobile]);

  const props = { mobile, navOpen };

  const LayoutGraphic = useCallback(() => {
    const current = navItems.find((x) => location.pathname.includes(x.route));
    return current.graphic ? <Graphic src={current.graphic} /> : null;
  }, [location.pathname]);

  return (
    <>
      <SideMenu {...props} />

      {/** Page content */}
      <Container {...props}>
        <Header
          headerRightContent={headerRightContent}
          {...props}
          setOpen={setNavOpen}
        />
        <MainWrapper
          {...props}
          onClick={() => {
            if (mobile) setNavOpen(false);
          }}
        >
          {mobile && (
            <>
              <Row>
                <UserInfoWrapper>
                  <UserInformation />
                </UserInfoWrapper>
              </Row>
              {headerRightContent && (
                <Row>
                  <HeaderRightContent>{headerRightContent}</HeaderRightContent>
                </Row>
              )}
            </>
          )}
          <Main>{children}</Main>
          <LayoutGraphic />
        </MainWrapper>
      </Container>
    </>
  );
};

export default Layout;

Layout.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
};
